export enum AuthStorageKeysEnum {
  AccessToken = 'accessToken',
  RefreshToken = 'refreshToken',
}
